/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedPriorRequestStatusList } from '../models/PaginatedPriorRequestStatusList';
import type { PatchedPriorRequestStatus } from '../models/PatchedPriorRequestStatus';
import type { PriorRequestStatus } from '../models/PriorRequestStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsPriorRequestStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedPriorRequestStatusList
     * @throws ApiError
     */
    public clientsPriorRequestStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedPriorRequestStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-prior-request-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns PriorRequestStatus
     * @throws ApiError
     */
    public clientsPriorRequestStatusCreate({
        requestBody,
    }: {
        requestBody: PriorRequestStatus,
    }): CancelablePromise<PriorRequestStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-prior-request-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PriorRequestStatus
     * @throws ApiError
     */
    public clientsPriorRequestStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this prior request status.
         */
        id: number,
    }): CancelablePromise<PriorRequestStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-prior-request-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns PriorRequestStatus
     * @throws ApiError
     */
    public clientsPriorRequestStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this prior request status.
         */
        id: number,
        requestBody: PriorRequestStatus,
    }): CancelablePromise<PriorRequestStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-prior-request-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PriorRequestStatus
     * @throws ApiError
     */
    public clientsPriorRequestStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this prior request status.
         */
        id: number,
        requestBody?: PatchedPriorRequestStatus,
    }): CancelablePromise<PriorRequestStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-prior-request-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsPriorRequestStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this prior request status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-prior-request-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
